export const isRequired = (requiredCredentials: any) =>
  requiredCredentials.length > 0 && requiredCredentials.some((c: any) => 
    c.credentialType === "USER_DEFINED" && c.genericCredentialType === "OTPMOBILEAPP"
  )